import { Environment } from './environment.model';
import { prismicClient } from '../prismic';

export const environment: Environment = {
    production: true,
    title: 'gotoitcareer DEV',
    baseUrl: 'https://apply-dev.gotoitcareer.com',
    backendUrl: 'https://api-dev.gotoitcareer.com',
    prismic: {
        client: prismicClient
    },
}
